// prettier-ignore
export default "2025.0726.1759"